var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NsSlottedDropdown",
    {
      class: [
        "slottedDropdown",
        { NsSlottedDropdown__small: _vm.size === "small" },
      ],
      attrs: {
        label: _vm.label,
        disabled: _vm.disabled,
        placeholder: _vm.placeholder,
        selected: _vm.selectedSku,
        tall: _vm.tall,
        "data-testid": "variantSelector",
      },
      on: { select: _vm.handleSelect },
    },
    _vm._l(_vm.variants, function (item) {
      return _c(
        "div",
        {
          key: item.id,
          class: _vm.$style.item,
          attrs: { "data-value": item.sku, title: item.variantDropdownLabel },
        },
        [
          !!item.shade
            ? _c("div", {
                class: _vm.$style.shade,
                style: { backgroundColor: item.shade },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { class: _vm.$style.label }, [
            _vm._v("\n      " + _vm._s(item.variantDropdownLabel) + "\n    "),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }